import React from 'react';
import { renderToString } from 'react-dom/server';

import { UserCircleIcon } from '../../../icon/regular';
import {
  InstructionActionTooltip,
  InstructionCSSClasses,
  InstructionEvent,
} from '../types';
import { addInstructionEvent, emitInstructionEvent } from '../utils';
import BlockInstruction from '../base-instruction/BlockInstruction';

class NameScriptInstructionBlock extends BlockInstruction {
  static initiable = false;

  get isInit() {
    return NameScriptInstructionBlock.initiable;
  }

  set isInit(value: boolean) {
    NameScriptInstructionBlock.initiable = value;
  }

  get instructionClasses() {
    return {
      wrapper: InstructionCSSClasses.NAME_SCRIPT_INSTRUCTION_BLOCK,
      action: InstructionCSSClasses.NAME_SCRIPT_INSTRUCTION_BLOCK_ACTION,
      content: InstructionCSSClasses.NAME_SCRIPT_INSTRUCTION_BLOCK_CONTENT,
    };
  }

  static get toolbox() {
    return {
      icon: renderToString(<UserCircleIcon style={{ height: 20 }} />),
      title: 'Name in script',
    };
  }

  get tooltip() {
    return InstructionActionTooltip.nameScript;
  }

  async openModal(instructionId: string) {
    emitInstructionEvent(
      this.api.events,
      InstructionEvent.OPEN_NAME_SCRIPT_INSTRUCTION_MODAL,
      {
        instructionId,
        isInline: false,
      },
    );
  }

  initEvents(): void {
    this.saveInstruction = this.saveInstruction.bind(this);
    addInstructionEvent(
      this.api.events,
      InstructionEvent.SAVE_NAME_SCRIPT_INSTRUCTION_BLOCK,
      this.saveInstruction,
    );
  }

  removeEvents(): void {
    this.api.events.off(
      InstructionEvent.SAVE_NAME_SCRIPT_INSTRUCTION_BLOCK,
      this.saveInstruction,
    );
  }
}

export default NameScriptInstructionBlock;
